import { DownloadUrls } from './types';

export const DEFAULT_DOWNLOAD_URLS: DownloadUrls = {
  PC: {
    development: 'https://static-dev.dhsf.996box.com/box_test/channel_app/996box500SetupSigned@10001.exe',
    test: 'https://static-dev.dhsf.996box.com/box_test/channel_app/996box500SetupSigned@10001.exe',
    pre: '',
    production: 'https://static.dhsf.996box.com/box/channel_app/996box501SetupSigned@10001.exe',
  },
  ANDROID: {
    development: 'https://static-dev.dhsf.996box.com/box_test/channel_app/1776651377000_ryaye.apk',
    test: 'https://static-dev.dhsf.996box.com/box_test/channel_app/1776651377000_ryaye.apk',
    pre: '',
    production: 'https://static.dhsf.996box.com/box/channel_app/1776679286000_yab8k.apk',
  },
};

export const BAIDU_DOWNLOAD_URLS: DownloadUrls = {
  PC: {
    development: 'https://static-dev.dhsf.996box.com/box_test/channel_app/996box500SetupSigned@10001.exe',
    test: 'https://static.dhsf.996box.com/box/channel_app/2026_ttsq_rxjh@4227.exe',
    pre: '',
    production: 'https://static.dhsf.996box.com/box/channel_app/2026_ttsq_rxjh@4227.exe',
  },
  ANDROID: {
    development: 'https://static-dev.dhsf.996box.com/box_test/channel_app/1776651377000_ryaye.apk',
    test: 'https://static.dhsf.996box.com/box/channel_app/1780300204_ZtteYg40mk.apk',
    pre: '',
    production: 'https://static.dhsf.996box.com/box/channel_app/1780300204_ZtteYg40mk.apk',
  },
};

export const BAIDU01_DOWNLOAD_URLS: DownloadUrls = {
  PC: {
    development: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80001.exe',
    test: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80001.exe',
    pre: '',
    production: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80001.exe',
  },
  ANDROID: {
    development: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
    test: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
    pre: '',
    production: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
  },
};

export const BAIDU02_DOWNLOAD_URLS: DownloadUrls = {
  PC: {
    development: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80002.exe',
    test: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80002.exe',
    pre: '',
    production: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80002.exe',
  },
  ANDROID: {
    development: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
    test: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
    pre: '',
    production: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
  },
};

export const BY_DOWNLOAD_URLS: DownloadUrls = {
  PC: {
    development: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80005.exe',
    test: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80005.exe',
    pre: '',
    production: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80005.exe',
  },
  ANDROID: {
    development: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
    test: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
    pre: '',
    production: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
  },
};

export const SO360_01_DOWNLOAD_URLS: DownloadUrls = {
  PC: {
    development: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80003.exe',
    test: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80003.exe',
    pre: '',
    production: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80003.exe',
  },
  ANDROID: {
    development: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
    test: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
    pre: '',
    production: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
  },
};

export const SO360_02_DOWNLOAD_URLS: DownloadUrls = {
  PC: {
    development: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80004.exe',
    test: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80004.exe',
    pre: '',
    production: 'https://static.dhsf.996box.com/box/channel_app/rxjhbox504_setup@80004.exe',
  },
  ANDROID: {
    development: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
    test: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
    pre: '',
    production: 'https://static.dhsf.996box.com/box/channel_app/1781068201_oChsidHf4A.apk',
  },
};

export const BAIDU_DOWNLOAD_CONFIGS = {
  BAIDU01: 'VmL4vSh1I1gCgu4xgdnWwBo4ctcLFH4g@aya4iEK1GHw9mA4xnDgEse0vt5XaqjMU',
  BAIDU02: 'WSBS7bPDGuHkMC8OrnCrowQxhdk6Dp0r@4mZtxhSuDAUEz2Yqm22ZJA3xb3wOLg1s',
};

export interface So360DownloadCallbackData {
  key: string;
  Secret: string;
  IDX: number;
}

export const S360_DOWNLOAD_CONFIGS: Record<string, So360DownloadCallbackData> = {
  SO360_01: {
    key: 'rtpj3xje28u17yeqgr3e',
    Secret: 'ax6hqfo3yo5ots993jgkeahbmis1pt72',
    IDX: 1, // 1: 360上报
  },
  SO360_02: {
    key: 'oa4q8n10mukbah0xksg6',
    Secret: 'ntq475jfs1pa4dqrjsvrkhxj09oy7ahq',
    IDX: 1, // 1: 360上报
  },
};
